var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconHowTo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.73 8.176a1.526 1.526 0 00-.645 1.305 1.208 1.208 0 11-2.417 0c0-1.42.657-2.527 1.62-3.243.927-.69 2.102-.998 3.213-.998 1.112 0 2.284.307 3.215.996.961.715 1.619 1.822 1.619 3.243 0 1.037-.327 1.825-.887 2.431-.442.479-1.01.805-1.402 1.03l-.123.072c-.452.264-.716.445-.894.682-.155.198-.32.531-.32 1.218a1.208 1.208 0 11-2.416 0c0-1.127.29-2.001.817-2.69.498-.65 1.14-1.034 1.595-1.298l.068-.038c.476-.278.72-.421.899-.617.12-.128.246-.319.246-.79a1.523 1.523 0 00-.645-1.305c-.43-.317-1.07-.515-1.772-.515-.7 0-1.338.198-1.771.52v-.003zM12.5 19.747a1.208 1.208 0 100-2.416 1.208 1.208 0 000 2.416zM.418 12.497a12.083 12.083 0 1124.167 0 12.083 12.083 0 01-24.167 0zm12.083-9.666a9.667 9.667 0 100 19.333 9.667 9.667 0 000-19.333z",
    fill: "#CDCDCD"
  })));
}

export default SvgIconHowTo;